const topicDetails = {
  kubernetes: { 
    title: "Kubernetes & Containerized Workloads", 
    content: "Deep dive into AWS EKS, autoscaling, and microservices orchestration."
  },
  "cloud-management": { 
    title: "Managing Cloud Services", 
    content: "Optimizing IAM, multi-cloud, and cost strategies."
  },
  serverless: { 
    title: "AWS API Gateway & Serverless", 
    content: "Exploring API Gateway, WebSockets, and Lambda scaling."
  },
  databases: { 
    title: "Scalable & Resilient Databases", 
    content: "Comparing DynamoDB, RDS, and globally replicated architectures."
  },
  "ai-cloud-automation": { 
    title: "AI-Driven Cloud Automation", 
    content: "Leveraging AI for automated scaling and security."
  },
  iot: { 
    title: "Real-Time Data Processing & IoT", 
    content: "Managing MQTT streams and AWS IoT Core efficiently."
  },

  iam: { 
    title: "AWS Identity and Access Management (IAM)", 
    content: "Secure control over AWS resources with users, groups, roles, and policies for authentication and authorization."
    
  },
  "ai-training": {  // ✅ NEW TOPIC: AI Training
    title: "AI Model Training & Optimization",
    content: "Live tracking of ANN, CNN, and Transformer models with real-time metrics."
  },
  "aimodels/ann": { 
    title: "ANN Model Details",
    content: "Detailed metrics and training progress for the Artificial Neural Network model."
  },
  "aimodels/cnn": { 
    title: "CNN Model Details",
    content: "Detailed metrics and training progress for the Convolutional Neural Network model."
  },
  "aimodels/transformer": { 
    title: "Transformer Model Details",
    content: "Detailed metrics and training progress for the Transformer model."
  }
};

export default topicDetails;